import { END_POINTS } from '../helpers';
import emptySplitApi from '../utils/rtk';

type CommonResponseType = {
  statusCode: number;
  message: string;
  data: any;
};

export const customerSupportApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getCustomerSupport: builder.query<
      CommonResponseType,
      { page: number; limit: number; search: string }
    >({
      query: ({ page, limit, search }) => ({
        url: `${END_POINTS.getCustomerSupport}?page=${page}&limit=${limit}&search=${search}`,
        method: 'GET',
      }),
    }),
    revertQuery: builder.mutation<CommonResponseType, { body: any }>({
      query: ({ body }) => ({
        url: `${END_POINTS.customerSupport}`,
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const { useLazyGetCustomerSupportQuery, useRevertQueryMutation } = customerSupportApi;
